import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import Html from '../../atoms/Html'

export const Container = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 2rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  padding: 3rem 1.5rem;
  gap: 2rem;
  @media ${mq(sizes.tablet)} {
    padding: 3rem 2rem;
  }
`
export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH3};
  margin: 0;
  color: ${({ theme }) => theme.colors.killarney};
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH2};
  }
`

export const Separator = styled.div`
  height: 0.1rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.fringyFlower};
  &:first-child {
    display: none;
  }
`

export const Tables = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: left;
  & th {
    ${({ theme }) => theme.textStyles.titleH5};
    color: ${({ theme }) => theme.colors.arapawa};
    padding-bottom: 1rem;
  }
  & td {
    border-top: 1px solid ${({ theme }) => theme.colors.offGreen};
    padding: 0.5rem 0.8rem;
    border-collapse: collapse;
    &:first-child {
      ${({ theme }) => theme.textStyles.textMediumStrong};
      color: ${({ theme }) => theme.colors.killarney};
      background-color: ${({ theme }) => theme.colors.floralWhite};
    }
    &:last-child {
      ${({ theme }) => theme.textStyles.textMedium};
      color: ${({ theme }) => theme.colors.arapawa};
    }
  }
  & tr:last-of-type {
    & td {
      border-bottom: 1px solid ${({ theme }) => theme.colors.offGreen};
    }
  }
`
export const Table = styled.table``

export const StyledOldTexts = styled(Html)`
  width: 100%;
  text-align: start;
`
